import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=e7852b5a"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7852b5a')) {
      api.createRecord('e7852b5a', component.options)
    } else {
      api.reload('e7852b5a', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=e7852b5a", function () {
      api.rerender('e7852b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/Wrapper.vue"
export default component.exports